import { render, staticRenderFns } from "./InformationWidget.vue?vue&type=template&id=89034858&scoped=true"
import script from "./InformationWidget.vue?vue&type=script&lang=js"
export * from "./InformationWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89034858",
  null
  
)

export default component.exports